export default {
  title: 'Imagen de regla de precios inteligente',
  select: {
    generate_title: 'Generar una imagen con IA',
    generate_subtitle: 'Lo crearemos basándonos en tu regla de precios inteligente.',
    generate_cta: 'Generar',
    upload_link: 'o sube desde tu dispositivo',
    rate_limit_company: {
      title: 'Necesitamos un momento',
      description: 'Tu restaurante ha generado muchas imágenes esta hora. Vuelve a intentarlo en {{time}}.',
    },
    rate_limit_smart_pricing_rule: {
      title: 'Tomando un breve descanso',
      description: 'Parece que has probado esta regla varias veces seguidas. Estaremos listos en {{time}}.',
    },
  },
  generating: {
    title: 'Generando tu imagen…',
    progress: {
      cooking: 'Preparando algo delicioso…',
      plating: 'Emplatando…',
      finishing: 'Añadiendo los últimos retoques…',
    },
  },
  preview: {
    alt: 'Imagen de regla de precios inteligente generada',
    hint: '¿No es correcto? Regenera o continúa para recortar la imagen.',
    click_to_expand: 'Clic para ampliar',
    regenerate: 'Regenerar',
    continue: 'Continuar para editar',
  },
  toasts: {
    upload_success: 'Imagen subida correctamente.',
    upload_failed: 'Error al subir la imagen.',
    delete_success: 'Imagen eliminada correctamente.',
    delete_failed: 'Error al eliminar la imagen.',
    generate_success: 'Imagen generada correctamente.',
    generate_failed: 'Error al iniciar la generación de imagen.',
    generate_timeout: 'La imagen se está generando. Aparecerá aquí cuando esté lista.',
    rate_limit_company: 'Límite de imágenes por hora alcanzado para este restaurante. Vuelve a intentarlo en {{time}}.',
    rate_limit_smart_pricing_rule: 'Demasiados intentos para esta regla ahora — vuelve a intentarlo en {{time}}.',
  },
  time: {
    seconds_one: '1 segundo',
    seconds_other: '{{count}} segundos',
    minutes_one: '1 minuto',
    minutes_other: '{{count}} minutos',
    hours_one: '1 hora',
    hours_other: '{{count}} horas',
  },
};
